define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/comm",
	"csi/xml",
	"./ChangeNode"
], function(declare,csi,_,comm,xml,ChangeNode) {

	var ATTR_PREFIX = "Attr_";
	var CREATE_NODE = "CreateNode";

	return declare(null, {

		constructor: function(writer, e) {
			this.writer = writer;
			this.element = e;
		},

		createNode: function(url, type, name) {
			var node = xml.e(this.writer.doc, CREATE_NODE, this.element);

			if (url)
				node.setAttribute(xml.PROP_URL, url);

			if (name)
				node.setAttribute(xml.PROP_NAME, name);

			if (type)
				node.setAttribute(xml.PROP_TYPE, type);

			this.writer._cannotCacheChange();

			return new ChangeNode(this.writer, node);
		},

		setModuleOperation: function(/*String*/module, /*String*/operation) {
			// summary: set the new module/operation pair
			this.element.setAttribute(comm.MODULE, module);
			this.element.setAttribute(comm.OPERATION, operation);
		},

		addGeneralizedParameter: function(id, type, value) {
			this.addParameter(ATTR_PREFIX + id, type, value);
		},

		addParameter: function(id, type, value) {
			if (value == null) return this;

			var	typeBase = xml.attributeTypeGetBase(type);
			var	doc = this.writer.doc;
			var	node = xml.e(doc, comm.PARAMETER, this.element);

			node.setAttribute(xml.PROP_ID, id);

			if (typeBase) {
				node.setAttribute(xml.PROP_TYPE, type);

				if (_.isArray(value)) {
					for (var i = 0; i < value.length; ++i) {
						xml.e(doc, typeBase, node).appendChild(doc.createTextNode(value[i]));
					}
				} else {
					csi.applyForEach(value, function(v, key) {
						var	e = xml.e(doc, typeBase, node);
						e.setAttribute(xml.PROP_KEY, key);
						e.appendChild(doc.createTextNode(String(v)));
					});
				}
			} else {
				node.setAttribute(xml.PROP_TYPE, type);
				value = String(value);

				if (value.indexOf('\n',0) >= 0) {
					node.appendChild(doc.createTextNode(value));
				} else {
					node.setAttribute(xml.PROP_VALUE, value);
				}
			}

			return this;
		},

		removeParameter: function(id) {
			// remove all instances of parameter
			var elemChildNodes = this.element.childNodes;
			for (var parIdx = elemChildNodes.length-1; parIdx >= 0; --parIdx) {
				var curParam = elemChildNodes[parIdx];
				if (curParam.nodeName != "Parameter") continue;

				if (curParam.getAttribute(xml.PROP_ID) == id) {
					this.element.removeChild(curParam);
				}
			}
		}
	});
});